import React from 'react';

const MiniPlayerContext = React.createContext({});
MiniPlayerContext.displayName = 'MiniPlayerContext';

export default MiniPlayerContext;
